import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath, isPlainObject } from "../../../../../utils";
import redirectMomo from "../../../../common/momo_redirection";

export default function view() {
  const $this = this;
  const { $charge, $inputs } = this;
  $this.CAN_SWITCH_TO_CONFIRM = false;


  return (view = ViewFactory({
    NAME: 'MOMO_GHANA_INIT_VIEW',
    inputs: ['network', 'phone', 'voucher'],
    mutables: { timerCurrent: 'CURRENT_TIME' },
    next() {
      const network = getValueAtPath($inputs, '[network].value');
      const phonenumber = getValueAtPath($inputs, '[phone].value');
      const voucher = getValueAtPath($inputs, '[voucher].value') || null;

      if (phonenumber && isPlainObject(network)) {
        $charge.init({
          data: { phonenumber, voucher, network: network.identifier },
          onRequireValidation() {
            $this.CAN_SWITCH_TO_CONFIRM = true;
          },

          onRequireRedirection() {
            const currentLocale = getValueAtPath($this, 'STATE.locale') || 'en';
            const isTestMode = getValueAtPath($this, 'STATE.isTestMode') || false;

            try {
              const { url } = this;

              redirectMomo(url, currentLocale, isTestMode)

            } catch(e) {}
          }
        });
      }
    }
  }).call(this));
}
